import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { COLORS } from '../../constants/constants';

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const LineChartComponent = ({ data }) => {
  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
      x: {
        // Configure x-axis ticks (labels)
        ticks: {
          autoSkip: false,  // Disable auto skipping for labels
          font: {
            size: 12, // Label font size
            weight: 'bold', // Label font weight
          },
          padding: 10, // Add padding between labels and bars
        },
      },
    },
    plugins: {
      legend: {
        position: 'bottom', // Position the legend at the bottom
        labels: {
          boxWidth: 20,  // Size of the legend box
          padding: 20,   // Space between legend items
          font: {
            size: 12, // Font size for the legend
            weight: 'bold',
          },
          usePointStyle: true,  // Use circles instead of squares for the legend
        },
      },
      tooltip: {
        enabled: true,  // Enable tooltips
        backgroundColor: 'rgba(0,0,0,0.8)',  // Tooltip background color
        titleColor: '#fff',  // Title color in tooltip
        bodyColor: '#fff',  // Body text color in tooltip
        footerColor: '#fff',  // Footer text color in tooltip
        callbacks: {
          title: (tooltipItem) => {
            return 'Custom Title: ' + tooltipItem[0].label;  // Custom title
          },
          label: (tooltipItem) => {
            return tooltipItem.dataset.label + ': ' + tooltipItem.raw + '%';  // Customize label
          },
        },
      },
    },
  };

  // Define colors based on the number of datasets
  const datasetColors = data.datasets.length === 2
    ? [COLORS.primary, COLORS.farmer]  // If 2 datasets, use primary and farmer colors
    : [COLORS.dues, COLORS.consultant, COLORS.primary]; // If 3 datasets, use custom colors

  // Map colors to each dataset
  const updatedData = {
    ...data,
    datasets: data.datasets.map((dataset, index) => ({
      ...dataset,
      borderColor: datasetColors[index] || COLORS.primary,         // Line color
      backgroundColor: `${datasetColors[index] || COLORS.primary}33`, // Slight transparency for fill
      fill: true, // Enable fill under the line
      pointBackgroundColor: datasetColors[index] || COLORS.primary,  // Circles at data points
      pointBorderColor: '#fff', // White border for the points
      pointBorderWidth: 2, // Border width of the circles
    })),
  };

  return <Line data={updatedData} options={options} />;
};

export default LineChartComponent;
